import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { Button } from '@/components/ui/button';

const UPDATE_EVENT = 'pwa-update-available';
const TOAST_ID = 'pwa-app-update';

/**
 * Listens for service worker update events (from virtual:pwa-register in main.jsx)
 * and shows a persistent toast until the user clicks "بروزرسانی".
 */
export default function PWAUpdateToast() {
  useEffect(() => {
    const onUpdate = (e) => {
      const reload = e.detail?.reload;
      if (typeof reload !== 'function') return;
      if (toast.isActive(TOAST_ID)) return;

      toast.info(
        <div className="flex flex-col gap-3 text-right" dir="rtl">
          <p className="font-medium text-sm">نسخه جدید برنامه آماده است.</p>
          <p className="text-xs text-muted-foreground">
            برای دریافت تغییرات، دکمه زیر را بزنید.
          </p>
          <Button
            type="button"
            size="sm"
            className="w-full"
            onClick={() => {
              toast.dismiss(TOAST_ID);
              reload().catch(() => {});
            }}
          >
            بروزرسانی
          </Button>
        </div>,
        {
          toastId: TOAST_ID,
          autoClose: false,
          closeOnClick: false,
          position: 'top-center',
        }
      );
    };

    window.addEventListener(UPDATE_EVENT, onUpdate);
    return () => window.removeEventListener(UPDATE_EVENT, onUpdate);
  }, []);

  return null;
}
